// extracted by mini-css-extract-plugin
export var downArrow = "_9q-0";
export var label = "_9q-1";
export var treatmentCard = "_9q-3";
export var upArrow = "_9q-2";